import { ReactElement } from "react";

import { ICatalogueSetItem } from "../../../apis/useGetCatalogueData/types";
import PaymentDetailSetItem from "./PaymentDetailSetItem";

interface IProps {
	setItems: ICatalogueSetItem[];
}

const PaymentDetailSetItems = ({ setItems }: IProps): ReactElement => {
	return (
		<ul className="CartItemSet">
			{setItems.map((setItem, setIndex) => (
				<PaymentDetailSetItem
					key={`${setItem.food_supplier_menu_item_id ?? ""}-${setItem.title ?? ""}-${setIndex}`}
					setItem={setItem}
				/>
			))}
		</ul>
	);
};

export default PaymentDetailSetItems;
